import 'tiny-slider/dist/tiny-slider.css';
import { TinySliderInstance, tns } from 'tiny-slider/src/tiny-slider';

const sliders: TinySliderInstance[] = [];

function setupCarousel(sliderElement: HTMLElement) {
  const sliderContainerElement: HTMLElement = sliderElement.querySelector('.carousel-wrapper');
  const coverWrapperElement: HTMLElement = sliderElement.querySelector('.carousel-covers');

  if (coverWrapperElement) {
    [...coverWrapperElement.children].forEach((slideCover: HTMLElement, index) => {
      slideCover.dataset.eqCarouselItemIndex = `${index + 1}`;
    });
  }

  if (sliderContainerElement) {
    const dataSetExtraSmall = parseInt(
      sliderContainerElement.dataset?.['eqSliderItemsToDisplayExtraSmall'],
      10,
    );
    const dataSetSmall = parseInt(
      sliderContainerElement.dataset?.['eqSliderItemsToDisplaySmall'],
      10,
    );
    const dataSetMedium = parseInt(
      sliderContainerElement.dataset?.['eqSliderItemsToDisplayMedium'],
      10,
    );
    const dataSetLarge = parseInt(
      sliderContainerElement.dataset?.['eqSliderItemsToDisplayLarge'],
      10,
    );
    const dataSetExtraLarge = parseInt(
      sliderContainerElement.dataset?.['eqSliderItemsToDisplayExtraLarge'],
      10,
    );
    const itemsToDisplayExtraSmall = isNaN(dataSetExtraSmall) ? 1 : dataSetExtraSmall;
    const itemsToDisplaySmall = isNaN(dataSetSmall) ? itemsToDisplayExtraSmall : dataSetSmall;
    const itemsToDisplayMedium = isNaN(dataSetMedium) ? itemsToDisplaySmall : dataSetMedium;
    const itemsToDisplayLarge = isNaN(dataSetLarge) ? itemsToDisplayMedium : dataSetLarge;
    const itemsToDisplayExtraLarge = isNaN(dataSetExtraLarge)
      ? itemsToDisplayLarge
      : dataSetExtraLarge;

    const prevButton: HTMLElement = sliderElement.querySelector('[aria-label=Previous]');

    const nextButton: HTMLElement = sliderElement.querySelector('[aria-label=Next]');

    const isSliderAlreadySetup = sliders.find((slider) => {
      slider.getInfo().container === sliderContainerElement;
    });

    if (!isSliderAlreadySetup) {
      const slider = tns({
        arrowKeys: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayHoverPause: true,
        autoplayTimeout: 6000,
        container: sliderContainerElement,
        slideBy: 'page',
        controls: true,
        controlsContainer: sliderElement.querySelector('.carousel-controls'),
        items: itemsToDisplayExtraSmall,
        loop: true,
        nav: true,
        navPosition: 'bottom',
        nextButton: nextButton,
        prevButton: prevButton,
        speed: 800,
        swipeAngle: false,
        responsive: {
          640: {
            items: itemsToDisplaySmall,
          },
          900: {
            items: itemsToDisplayMedium,
          },
          1000: {
            items: itemsToDisplayLarge,
          },
          1280: {
            items: itemsToDisplayExtraLarge,
          },
        },
      });
      sliders.push(slider);
    }
  }
}
const Slider = {
  init: () => {
    const sliderElements = document.querySelectorAll('[aria-label=slider]');

    sliderElements?.forEach((sliderElement: HTMLElement) => {
      setupCarousel(sliderElement);
    });
  },
  initAfter: (sliderElement: HTMLElement) => {
    setupCarousel(sliderElement);
  },
};

export default Slider;
